import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-thank-you',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './thank-you.component.html',
    styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {
    ngOnInit(): void {
        // Optional: Auto-redirect to login after 10 seconds
        // setTimeout(() => { /* logic here */ }, 10000);
    }
}
